<template>
  <div class="home page-container" >
    <!-- <b2bHome v-if="this.business === true" />
    <b2cHome v-else/> -->
    <b2cHome/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import b2cHome from './b2cHome';
import b2bHome from './b2bHome';

export default {
  name: "home",
  components: {
    b2cHome,
    b2bHome,
  },
  metaInfo() {
    return {
      title: `Elegant Granite`,
      meta: [
        { name: 'description', content: `` },
        { name: 'keywords', content: "" },
        { name: 'robots', content: "index,follow" }
      ]
    }
  },
  computed: mapState ({
    business: state => state.auth.userDetails.IsBusiness,
  }),
  mounted() {
    this.$store.dispatch('billboard/fetchBillboardImages');
  },
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/home.less";
</style>



// WEBPACK FOOTER //
// src/view/Home/home.vue